import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import masterService from "../../Services/masterService";
import Loader from "../../Components/Loader";
import { PhoneCode } from "../../Components";

export const EditCommercial = () => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const data = history.location.state;
  let param = new URLSearchParams(history.location.search);
  useEffect(() => {
    onDetail();
  }, []);
  const formik = useFormik({
    initialValues: {
      commercial_name: "",
      commercial_type: "",
      phone_number: "",
      commercial_email: "",
      address: "",
      taxation_details: "",
      total_discount: "",
      contact_person: "",
    },
    validationSchema: Yup.object({
      commercial_name: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      commercial_type: Yup.string().required("Required"),
      commercial_email: Yup.string()
        .required("Required")
        .email("Please enter valide email"),
      phone_number: Yup.string()
        .typeError("Must be a number")
        .required("Required")
        .min(10, "Too short")
        .max(12, "Too long"),
      taxation_details: Yup.string().required("Required"),
      total_discount: Yup.number()
        .typeError("Must be a number")
        .required("Required"),
      contact_person: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      let postData = {
        commercial_name: values.commercial_name,
        address: values.address,
        commercial_type: values.commercial_type,
        commercial_email: values.commercial_email.toLowerCase(),
        phone_number: values.phone_number,
        taxation_details: values.taxation_details,
        total_discount: values.total_discount,
        contact_person: values.contact_person,
        id: param.get("id"),
      };
      setLoader(true);

      masterService.updateCommercial(postData).then((res) => {
        if (res.status) {
          setLoader(false);
          history.push("/commercials-list");
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  const onDetail = () => {
    let postData = {
      id: param.get("id"),
    };
    masterService.get_commercial_details(postData).then((res) => {
      if (res.status) {
        formik.setValues({
          commercial_name: res.data.commercial_name,
          commercial_type: res.data.commercial_type,
          phone_number: res.data.phone_number,
          commercial_email: res.data.commercial_email,
          address: res.data.address,
          taxation_details: res.data.taxation_details,
          total_discount: res.data.total_discount,
          contact_person: res.data.contact_person,
        });
      }
    });
  };

  

  return (
    <div className="row justify-content-md-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 col-12">
                  <label className="form-label">Commercial Name</label>
                  <input
                    required={false}
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.commercial_name
                        ? !formik.errors.commercial_name
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("commercial_name")}
                    placeholder="Enter Commercial Name"
                  />
                  {formik.touched.commercial_name &&
                  formik.errors.commercial_name ? (
                    <div className="text-danger">
                      {formik.errors.commercial_name}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Contact Person</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.contact_person
                        ? !formik.errors.contact_person
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("contact_person")}
                    placeholder="Enter Contact Person"
                  />
                  {formik.touched.contact_person &&
                  formik.errors.contact_person ? (
                    <div className="text-danger">
                      {formik.errors.contact_person}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <div className="form-group border">
                    <label className="form-label">Contact No.</label>
                    <div
                      className={
                        formik.touched.phone_number
                          ? !formik.errors.phone_number
                            ? " contact-success"
                            : " contact-error"
                          : ""
                      }
                    >
                      <PhoneCode
                        Addphone={(value) =>
                          formik.setValues({
                            ...formik.values,
                            phone_number: value,
                          })
                        }
                        phone={formik.values.phone_number}
                      />
                    </div>
                  </div>
                  {formik.touched.phone_number && formik.errors.phone_number ? (
                    <div className="text-danger">
                      {formik.errors.phone_number}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Email ID</label>
                  <input
                    type="email"
                    className={
                      "form-control" +
                      (formik.touched.commercial_email
                        ? !formik.errors.commercial_email
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("commercial_email")}
                    placeholder="Enter Email"
                  />
                  {formik.touched.commercial_email &&
                  formik.errors.commercial_email ? (
                    <div className="text-danger">
                      {formik.errors.commercial_email}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label">Registered Address</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.address
                        ? !formik.errors.address
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("address")}
                    placeholder="Enter Business Address"
                  />
                  {formik.touched.address && formik.errors.address ? (
                    <div className="text-danger">{formik.errors.address}</div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-6">
                  <label className="form-label">Taxation Details</label>
                  <input
                    type="text"
                    className={
                      "form-control" +
                      (formik.touched.taxation_details
                        ? !formik.errors.taxation_details
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("taxation_details")}
                    placeholder="Enter Taxation Details"
                  />
                  {formik.touched.taxation_details &&
                  formik.errors.taxation_details ? (
                    <div className="text-danger">
                      {formik.errors.taxation_details}
                    </div>
                  ) : null}
                </div>
                <div className="mb-3 col-6">
                  <label className="form-label">Total Discount</label>
                  <input
                    className={
                      "form-control" +
                      (formik.touched.total_discount
                        ? !formik.errors.total_discount
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...formik.getFieldProps("total_discount")}
                    placeholder="Enter Total Discount"
                  />
                  {formik.touched.total_discount &&
                  formik.errors.total_discount ? (
                    <div className="text-danger">
                      {formik.errors.total_discount}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
